module.exports = __webpack_public_path__ + "static/media/hero-8.152104af.jpg";